import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgKeyLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M15.25 7.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M15.25 2c-1.704 0-3.23.86-4.56 2.19S8.5 7.045 8.5 8.75c0 .804.192 1.572.537 2.299l-5.244 5.244a1 1 0 0 0-.274.903l.5 2.5A1 1 0 0 0 5 20.5h2.5a1 1 0 0 0 .832-.445l1.703-2.555H11.5a1 1 0 0 0 .832-.445l1.228-1.843a5.2 5.2 0 0 0 1.69.288c1.704 0 3.23-.86 4.56-2.19S22 10.455 22 8.75c0-1.705-.86-3.23-2.19-4.56S16.956 2 15.25 2m-3.146 3.604C13.217 4.49 14.264 4 15.25 4s2.033.49 3.146 1.604C19.51 6.717 20 7.764 20 8.75s-.49 2.033-1.604 3.146c-1.113 1.113-2.16 1.604-3.146 1.604-.522 0-1.05-.135-1.597-.42a1 1 0 0 0-1.295.33l-1.393 2.09H9.5a1 1 0 0 0-.832.445L6.965 18.5H5.82l-.234-1.171 5.396-5.396a1 1 0 0 0 .138-1.241c-.424-.671-.62-1.314-.62-1.942 0-.986.49-2.033 1.604-3.146'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgKeyLine)
export default ForwardRef
